import { useCallback, type ChangeEvent } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  TextField,
  Box,
} from '@material-ui/core';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export interface GitLabUsernameConditionalValue {
  is_different: boolean;
  username?: string;
}

const defaultValue: GitLabUsernameConditionalValue = {
  is_different: false,
  username: '',
};

export const GitLabUsernameConditionalField = ({
  onChange,
  rawErrors,
  formData,
}: FieldExtensionComponentProps<GitLabUsernameConditionalValue>) => {
  const value: GitLabUsernameConditionalValue = formData ?? defaultValue;

  const handleCheckChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange({
        ...value,
        is_different: checked,
        username: checked ? value.username : undefined,
      });
    },
    [value, onChange],
  );

  const handleUsernameChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange({
        ...value,
        username: e.target.value?.trim() || undefined,
      });
    },
    [value, onChange],
  );

  const error = rawErrors && rawErrors.length > 0;

  return (
    <FormControl margin="normal" error={error} fullWidth>
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={value.is_different ?? false}
              onChange={handleCheckChange}
              color="primary"
            />
          }
          label="GitLab username is different from firstname.lastname, firstname.lastname.contr, firstname.lastname.prtnr"
        />
      </Box>
      {value.is_different && (
        <TextField
          margin="normal"
          fullWidth
          label="GitLab username"
          placeholder="Enter your GitLab username"
          value={value.username ?? ''}
          onChange={handleUsernameChange}
          variant="outlined"
        />
      )}
      <FormHelperText error={error}>
        {rawErrors?.[0]}
      </FormHelperText>
    </FormControl>
  );
};
